export const formatNumber = (value: string | number): string => {
    if (value === undefined || value === null || value === '') return '';
    const num =
        typeof value === 'string' ? parseInt(value.replace(/\s/g, ''), 10) : value;
    if (isNaN(num)) return '';
    return num.toLocaleString('ru-RU');
};


export const cleanNumber = (value: string) => value.replace(/\s/g, '');
